export default __webpack_public_path__ + "static/media/Panda.554e045a.jpg";